<template>
  <v-dialog v-model="dialog" scrollable max-width="520" persistent>
    <v-card>
      <v-toolbar dense flat light class="grey lighten-2">
        <v-toolbar-title class="text-body-1 font-weight-bold">
          {{ $t("m.estimation") }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon color="" @click="handleAdd">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn icon color="" @click="handleCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-progress-linear
          :active="isLoading"
          :indeterminate="isLoading"
          absolute
          bottom
          color="deep-purple accent-4"
        />
      </v-toolbar>
      <v-divider />

      <v-card flat tile class="" style="height: 520px; overflow-y: auto">
        <template v-if="items.length > 500">
          <v-card flat tile class="mb-1 pa-2 text-center" color="transparent">
            <v-text-field
              v-model="filterName"
              style="width: 280px"
              prepend-inner-icon="mdi-magnify"
              :placeholder="$t('m.estiName')"
              dense
              hide-details
            />
          </v-card>
        </template>
        <template v-if="items.length > 0">
          <v-list dense class="mx-2 my-1">
            <v-list-item-group v-model="selectedItem" color="primary">
              <template v-for="(item, index) in items">
                <v-list-item class="px-2">
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-body-2"
                      v-text="item.ESTIDESC"
                    />
                    <div class="mt-1 text-caption grey--text">
                      {{ item.LASTMODIFYTIME | timFormat }}
                    </div>
                  </v-list-item-content>
                  <v-list-item-action class="d-inline-block">
                    <v-btn
                      icon
                      color="grey"
                      @click="handleView(item.ESTIID, index)"
                    >
                      <v-icon small> mdi-eye </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      class="ml-1"
                      @click="confirmDel(item.ESTIID, index)"
                    >
                      <v-icon small> mdi-delete </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      class="ml-1"
                      @click="edit(item.ESTIID, index)"
                    >
                      <v-icon small> mdi-pencil </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index < items.length - 1" />
              </template>
            </v-list-item-group>
          </v-list>
        </template>
        <template v-if="items.length == 0 && !isLoading">
          <v-card flat tile class="text-center mt-16" style="">
            {{ $t("m.noRecord") }}
            <v-btn
              class="ml-4"
              small
              depressed
              color="primary"
              @click="handleAdd"
            >
              <v-icon left> mdi-plus </v-icon>
              Add
            </v-btn>
          </v-card>
        </template>
      </v-card>
    </v-card>

    <AlertConfirmDlg
      :visible="alertConfirmDlgVisible"
      :title="alertTitle"
      :content="alertContent"
      @cancel="cancelAlertDlg"
      @confirm="confirmAlertDlg"
    />

    <EstimationEditDialog
      :visible="estEditDlgVisible"
      :esti-i-d="currId"
      :view-flag="viewFlag"
      @cancel="cancelEditEstimation"
      @save="handleEstiSave"
    />
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Utils from "@/utils/index";
import httpClient from "@/api/httpClient";
import dayjs from "dayjs";
import EstimationEditDialog from "@/views/EstimationEditDialog";
import AlertConfirmDlg from "@/components/AlertConfirmDlg";

export default {
  name: "EstimationDialog",
  components: {
    EstimationEditDialog,
    AlertConfirmDlg,
  },
  props: ["visible"],
  data() {
    return {
      dialog: false,
      selectedItem: null,
      estEditDlgVisible: false,
      viewFlag: false,

      overlay: false,
      isLoading: false,
      items: [],
      filterName: null,

      alertConfirmDlgVisible: false,
      alertTitle: "",
      alertContent: "",

      currId: null,
      currIndex: null,
      skeletonAttrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 1,
      },
    };
  },
  computed: {
    ...mapState({
      userLogoutClearFlag: (state) => state.user.userLogoutClearFlag,
    }),
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
      this.query();
    },

    userLogoutClearFlag: function (val) {
      if (val) {
        this.items = [];
      }
    },
  },
  created() {},
  mounted() {},
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },

  methods: {
    query() {
      this.isLoading = true;
      this.overlay = true;
      var json = {
        OperID: Utils.getWithExpiry("operID"),
      };
      httpClient
        .post("/ATVoyageEstiListQry", json)
        .then((res) => {
          this.isLoading = false;
          this.overlay = false;
          this.items = res.data;
          // console.log(this.items)
        })
        .catch((err) => {
          this.isLoading = false;
          this.overlay = false;
        });
    },

    confirmDel(id, index) {
      this.currId = id;
      this.currIndex = index;
      this.alertContent = this.$t("m.comfirmDelEsti");
      this.alertConfirmDlgVisible = true;
    },
    cancelAlertDlg() {
      this.alertConfirmDlgVisible = false;
    },
    confirmAlertDlg() {
      this.alertConfirmDlgVisible = false;
      this.del();
    },
    del() {
      this.isLoading = true;
      var json = {
        OperID: Utils.getWithExpiry("operID"),
        EstiID: this.currId,
      };
      httpClient
        .post("/ATVoyageEstiDel", json)
        .then((res) => {
          this.isLoading = false;
          this.items.splice(this.currIndex, 1);
          this.currId = null;
          this.currIndex = null;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },

    edit(estiID, index) {
      this.currId = estiID;
      this.currIndex = index;
      this.estEditDlgVisible = true;
    },

    handleView(estiID, index) {
      this.currId = estiID;
      this.currIndex = index;
      this.viewFlag = true;
      this.estEditDlgVisible = true;
    },

    handleCancel() {
      this.dialog = false;
      this.currId = null;
      this.$emit("cancel");
    },

    handleAdd() {
      this.currId = null;
      this.estEditDlgVisible = true;
    },

    handleEstiSave() {
      this.query();
      this.estEditDlgVisible = false;
    },

    cancelEditEstimation() {
      this.estEditDlgVisible = false;
      this.viewFlag = false;
    },
  },
  filters: {
    timFormat: function (val) {
      if (!val) return "";
      return dayjs(val).format("YYYY/MM/D HH:mm");
    },
  },
};
</script>

<style scoped lang="scss"></style>
